import React from 'react';

const PemutusanKontrak = () => {
  return (
    <h1>Pemutusan Kontrak</h1>
  );
};

export default PemutusanKontrak;





